import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=5336f61b&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=ts"
export * from "./Tags.vue?vue&type=script&lang=ts"
import style0 from "./Tags.vue?vue&type=style&index=0&id=5336f61b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5336f61b",
  null
  
)

export default component.exports